import { render, staticRenderFns } from "./booking_update_history.vue?vue&type=template&id=089338c2&scoped=true&"
import script from "./booking_update_history.vue?vue&type=script&lang=js&"
export * from "./booking_update_history.vue?vue&type=script&lang=js&"
import style0 from "./booking_update_history.vue?vue&type=style&index=0&id=089338c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089338c2",
  null
  
)

export default component.exports